import React, { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Card, CardContent } from '../components/ui/card';
import { Badge } from '../components/ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import { Dialog, DialogContent, DialogTrigger } from '../components/ui/dialog';
import { X } from 'lucide-react';

export const GalleryPage = () => {
  const [activeTab, setActiveTab] = useState('tous');

  // Photos des burgers (vous pourrez remplacer par vos propres photos)
  const burgerPhotos = [
    {
      id: 1,
      name: 'LE TY BREIZH',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/0ns9e93j_Ty%20breizh.JPG',
      category: 'burger',
      description: 'Notre burger signature avec bacon et cheddar'
    },
    {
      id: 2,
      name: 'LE TY BIQUETTE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/skltq0b2_Ty%20biquette.JPG',
      category: 'burger',
      description: 'Chèvre fondant et lard grillé'
    },
    {
      id: 3,
      name: 'LE TY CAM',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/ptz8gl2c_Ty%20cam.JPG',
      category: 'burger',
      description: 'Camembert coulant et chorizo'
    },
    {
      id: 4,
      name: 'LE TY COMTÉ',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/02aee9wu_comt%C3%A9.jpg',
      category: 'burger',
      description: 'Comté, cornichons et roquette'
    },
    {
      id: 5,
      name: 'L\'ITALIEN',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/t89eurfu_Italien.JPG',
      category: 'burger',
      description: 'Pesto maison et jambon serrano'
    },
    {
      id: 6,
      name: 'L\'ÉCOSSAIS',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/5i79uq2m_ecossais.jpg',
      category: 'burger',
      description: 'Avec notre sauce whisky 12 ans d\'âge'
    },
    {
      id: 7,
      name: 'LE JAP\'',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/yh9czy8j_Le%20Jap%27.jpg',
      category: 'burger',
      description: 'Burger du mois - Saveurs asiatiques'
    },
    {
      id: 8,
      name: 'LE MEXICAIN',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/ozthoq4i_M%C3%A9xicain.jpg',
      category: 'burger',
      description: 'Burger du mois - Guacamole et nachos'
    },
    {
      id: 9,
      name: 'LE DOUBLE CHEESY',
      image: 'https://images.unsplash.com/photo-1550547660-d9450f859349',
      category: 'burger',
      description: 'Double steak, double plaisir'
    },
  ];

  // Photos des pizzas
  const pizzaPhotos = [
    {
      id: 10,
      name: 'LA TARTIFLETTE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/61l2zplo_Tartiflette.JPG',
      category: 'pizza',
      description: 'Reblochon au lait cru de Savoie'
    },
    {
      id: 11,
      name: 'LA SEGUIN',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/g7a5e92v_Seguin.JPG',
      category: 'pizza',
      description: 'Miel, chèvre et noix'
    },
    {
      id: 12,
      name: 'LA ROYALE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/chsaeqm4_Royale.JPG',
      category: 'pizza',
      description: 'Champignons, jambon et œuf'
    },
    {
      id: 13,
      name: 'LA PÉRIGOURDINE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/uzmcabm0_Perigourdine.JPG',
      category: 'pizza',
      description: 'Magret de canard et champignons'
    },
    {
      id: 14,
      name: 'LA NORDIQUE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/f62qe4j9_Nordique.JPG',
      category: 'pizza',
      description: 'Saumon frais et fondue de poireaux'
    },
    {
      id: 15,
      name: 'LA MONTAGNARDE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/8wf0yqxq_Montagnarde.JPG',
      category: 'pizza',
      description: 'Raclette et jambon serrano'
    },
    {
      id: 16,
      name: 'L\'ITALIENNE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/st5ssihp_Italienne.JPG',
      category: 'pizza',
      description: 'Roquette, parmesan et jambon serrano'
    },
    {
      id: 17,
      name: 'LA MÉDITÉRRANÉENNE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/q9fnd431_Mediterraneenne.JPG',
      category: 'pizza',
      description: 'Bœuf épicé, poivrons et merguez'
    },
    {
      id: 18,
      name: 'LA CATALANE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/symeqi72_Catalane.JPG',
      category: 'pizza',
      description: 'Thon, oignons et anchois'
    },
    {
      id: 19,
      name: 'L\'INDIENNE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/fghz5hjc_Indienne.JPG',
      category: 'pizza',
      description: 'Poulet curry maison et chorizo'
    },
    {
      id: 20,
      name: 'L\'ARIZONA',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/dyg91osa_Arizona.JPG',
      category: 'pizza',
      description: 'Bœuf épicé, cheddar et sauce BBQ'
    },
    {
      id: 21,
      name: 'LA GOURMANDE',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/55tiggm9_Gourmande.JPG',
      category: 'pizza',
      description: 'Pizza généreuse aux multiples garnitures'
    },
    {
      id: 22,
      name: 'LA BREIZHIZEL',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/fjanln5x_Breizhizel.JPG',
      category: 'pizza',
      description: 'Spécialité bretonne'
    },
    {
      id: 23,
      name: 'LA 4 SAISONS',
      image: 'https://customer-assets.emergentagent.com/job_mod-recharge/artifacts/3r18nsah_4%20Saisons.JPG',
      category: 'pizza',
      description: 'Champignons, oignons, poivrons et olives'
    },
    {
      id: 24,
      name: 'LA MARGHERITA',
      image: 'https://images.unsplash.com/photo-1574071318508-1cdbab80d002',
      category: 'pizza',
      description: 'La classique italienne'
    },
    {
      id: 25,
      name: 'LA CALZONE',
      image: 'https://images.unsplash.com/photo-1563245738-9169ff58eccf',
      category: 'pizza',
      description: 'Pizza soufflée généreuse'
    },
  ];

  const allPhotos = [...burgerPhotos, ...pizzaPhotos];

  const filteredPhotos = activeTab === 'tous' 
    ? allPhotos 
    : activeTab === 'burgers'
    ? burgerPhotos
    : pizzaPhotos;

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="pt-24 pb-12 sm:pt-32 sm:pb-16 bg-gradient-subtle">
        <div className="container mx-auto px-4 sm:px-6">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-4 sm:mb-6">
              Notre Galerie
            </h1>
            <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
              Découvrez en images nos créations artisanales préparées avec passion
            </p>
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="py-12 sm:py-16 bg-background">
        <div className="container mx-auto px-4 sm:px-6">
          {/* Tabs Filter */}
          <Tabs defaultValue="tous" className="w-full" onValueChange={setActiveTab}>
            <TabsList className="grid w-full max-w-md mx-auto grid-cols-3 mb-12 bg-muted">
              <TabsTrigger value="tous" className="text-base font-medium">
                Tous
              </TabsTrigger>
              <TabsTrigger value="burgers" className="text-base font-medium">
                Burgers
              </TabsTrigger>
              <TabsTrigger value="pizzas" className="text-base font-medium">
                Pizzas
              </TabsTrigger>
            </TabsList>

            {/* Gallery Grid */}
            <TabsContent value={activeTab} className="mt-0">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
                {filteredPhotos.map((photo) => (
                  <Dialog key={photo.id}>
                    <DialogTrigger asChild>
                      <Card className="group cursor-pointer overflow-hidden border-border shadow-soft hover:shadow-strong transition-all duration-300 hover:-translate-y-2 bg-card">
                        <div className="relative aspect-square overflow-hidden">
                          <img
                            src={photo.image}
                            alt={photo.name}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          />
                          <div className="absolute inset-0 bg-gradient-to-t from-accent/90 via-accent/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                          <Badge
                            variant="outline"
                            className="absolute top-4 right-4 bg-background/90 backdrop-blur-sm border-border"
                          >
                            {photo.category === 'burger' ? '🍔 Burger' : '🍕 Pizza'}
                          </Badge>
                        </div>
                        <CardContent className="p-6">
                          <h3 className="text-xl font-semibold text-foreground mb-2">
                            {photo.name}
                          </h3>
                          <p className="text-sm text-muted-foreground leading-relaxed">
                            {photo.description}
                          </p>
                        </CardContent>
                      </Card>
                    </DialogTrigger>
                    <DialogContent className="max-w-4xl p-0 overflow-hidden">
                      <div className="relative">
                        <img
                          src={photo.image}
                          alt={photo.name}
                          className="w-full h-auto"
                        />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-accent/95 to-transparent p-6">
                          <h3 className="text-2xl font-bold text-background mb-2">
                            {photo.name}
                          </h3>
                          <p className="text-background/90">{photo.description}</p>
                        </div>
                      </div>
                    </DialogContent>
                  </Dialog>
                ))}
              </div>
            </TabsContent>
          </Tabs>

          {/* Info Banner */}
          <div className="mt-16 p-6 sm:p-8 bg-primary/10 border-2 border-primary/30 rounded-lg text-center max-w-4xl mx-auto">
            <h3 className="text-xl sm:text-2xl font-bold text-foreground mb-2">
              📸 Vos Photos
            </h3>
            <p className="text-sm sm:text-base text-muted-foreground">
              Partagez vos moments P&G sur Instagram avec #PGPizzaGourmandises
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GalleryPage;